module.exports = __webpack_public_path__ + "img/closed-door.7503fd40.svg";